import { Checkbox, Paper, Text } from '@mantine/core';

type CancellationCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

const CancellationCheckbox: React.FC<CancellationCheckboxProps> = ({ checked, onChange }) => (
  <Paper bg="gray.0" px="md" py="sm" radius="sm" shadow="none">
    <Checkbox
      label={
        <Text fz="xs">
          <Text span fw={600} c="black" fz="sm">
            Cancellation notice (required)
          </Text>
          <br />
          <Text span c="gray.7" fz="xs">
            I understand a fee may apply if I cancel with less than{' '}
            <Text span fw={600} c="black" fz="xs">
              48 hours
            </Text>{' '}
            notice.
          </Text>
        </Text>
      }
      checked={checked}
      onChange={(event) => onChange(event.currentTarget.checked)}
      size="sm"
      styles={{
        input: {
          borderColor: 'var(--mantine-primary-color-filled)',
        },
      }}
    />
  </Paper>
);

export default CancellationCheckbox;
